import RealDialog from './code/Scripts/Components/real-dialog.vue';

export default {
  components: {
    RealDialog,
  },
};
